(function() {
	'use strict';

	angular.module('requestApp').controller('CheckIDNumDialogController',
			CheckIDNumDialogController);

	CheckIDNumDialogController.$inject = [ '$scope', '$uibModalInstance',
			'items', 'NgTableParams' ];

	function CheckIDNumDialogController($scope, $uibModalInstance, items,
			NgTableParams) {
		var checkCtrl = this;
		var data = items;
		checkCtrl.items = items;
		checkCtrl.tableParams = new NgTableParams({
			page : 1, // show first page
			count : 5
		// count per page
		}, {
			filterDelay : 0,
			dataset : data
		});

		checkCtrl.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		};

		checkCtrl.selected = function(index) {
			$uibModalInstance.close(index);
		}
	}
})();
